import script from "./HealthWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthWarning.vue?vue&type=script&setup=true&lang=js"

import "./HealthWarning.vue?vue&type=style&index=0&id=94d92cc0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94d92cc0"]])

export default __exports__